/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Badge_BystepInputs */

const en_pb_badge_bystep = /** @type {(inputs: Pb_Badge_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by Bystep`)
};

const id_pb_badge_bystep = /** @type {(inputs: Pb_Badge_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari Bystep`)
};

/**
* | output |
* | --- |
* | "by Bystep" |
*
* @param {Pb_Badge_BystepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_badge_bystep = /** @type {((inputs?: Pb_Badge_BystepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Badge_BystepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_badge_bystep(inputs)
	return en_pb_badge_bystep(inputs)
});